<app-project-list
  *ngIf="showProjects"
  [isAdmin]="isAdmin"
  [getUnreadMessages]="getUnreadMessages"
  (projectSelected)="onProjectSelected($any($event))"
  (projectArchived)="onProjectArchived($any($event))">
</app-project-list>

<!-- Sidebar -->
<div class="chat-container" *ngIf="!showProjects">
  <app-topic-sidebar
    [selectedProject]="selectedProject"
    [isAdmin]="isAdmin"
    (topicSelected)="onTopicSelected($any($event))"
    (backToProjectList)="backToProjects()">
  </app-topic-sidebar>


  <section class="chat-area" *ngIf="selectedTopic" [class.chat-area-expanded]="!showSidebar">
    <header>
      <div class="header-content">
        <div class="title-container">
          <h2 *ngIf="!isEditingTitle">{{ selectedTopic.title }}</h2>
          <div class="title-edit" *ngIf="isEditingTitle">
            <input
              type="text"
              [(ngModel)]="editingTitle"
              class="title-input"
              [ngClass]="{'error': hasTitleCyrillicError}"
              (keyup.enter)="saveTitleEdit()"
              (keyup.escape)="cancelTitleEdit()"
              #titleInput
            />
            <div class="error-message" *ngIf="hasTitleCyrillicError">
              {{ cyrillicErrorMessage }}
            </div>
            <div class="title-edit-actions">
              <button class="btn btn-primary" (click)="saveTitleEdit()">Save</button>
              <button class="btn btn-secondary" (click)="cancelTitleEdit()">Cancel</button>
            </div>
          </div>
          <button
            *ngIf="isAdmin"
            class="edit-title-btn"
            (click)="toggleTitleEdit()"
            [ngClass]="{'editing': isEditingTitle}"
            ngbTooltip="Edit Topic Title">
            <i class="edit-icon"></i>
          </button>
        </div>
        <div class="topic-status" [ngClass]="{
          'new': selectedTopic.status === 'NEW',
          'admin-review': selectedTopic.status === 'ADMIN_REVIEW',
          'sent-to-customer': selectedTopic.status === 'SENT_TO_CUSTOMER',
          'resolved': selectedTopic.status === 'RESOLVED'
        }">
          <i class="status-icon"></i>
          <span class="status-text" *ngIf="!isAdmin || !isEditingStatus">{{ selectedTopic.status }}</span>
          <select
            *ngIf="isAdmin && isEditingStatus"
            [(ngModel)]="selectedTopic.status"
            (change)="onStatusChange()"
            class="status-select">
            <option value="NEW">New</option>
            <option value="ADMIN_REVIEW">Admin Review</option>
            <option value="SENT_TO_CUSTOMER">Sent to Customer</option>
            <option value="RESOLVED">Resolved</option>
          </select>
          <button
            *ngIf="isAdmin"
            class="edit-status-btn"
            (click)="toggleStatusEdit()"
            [ngClass]="{'editing': isEditingStatus}"
            ngbTooltip="Edit Topic Status">
            <i class="edit-icon"></i>
          </button>
        </div>
      </div>
    </header>

    <div class="messages" #messagesContainer>
      <div *ngFor="let msg of messages"
           [ngClass]="{
             'message': true,
             'message-sent': isMyMessage(msg),
             'message-received': !isMyMessage(msg),
             'customer-admin-message': isCustomerAdminMessage(msg)
           }">
        <div class="message-header">
          <strong>{{ msg.authorName }}</strong>
          <span class="message-role" *ngIf="isCustomerAdminMessage(msg)">*sent to customer</span>

          <div class="admin-actions">
            <button class="copy-message-btn" (click)="copyMessage(msg)" ngbTooltip="Copy Message">
              <i class="copy-icon"></i>
            </button>
            <ng-container *ngIf="isAdmin">
              <button class="edit-message-btn" (click)="toggleMessageEdit(msg)" ngbTooltip="Edit Message" [ngClass]="{'editing': isEditingMessage === msg.id}">
                <i class="edit-icon"></i>
              </button>
              <button class="ask-customer-btn" (click)="toggleCustomerSelection(msg)" ngbTooltip="Ask Customer" [ngClass]="{'active': isSelectingCustomer === msg.id}">
                <i class="customer-icon"></i>
              </button>
              <div class="customer-dropdown" *ngIf="isSelectingCustomer === msg.id">
                <div class="customer-list">
                  <div class="customer-item" *ngFor="let customer of filteredCustomers; trackBy: trackByEmail" (click)="selectCustomerForTopic(customer)">

                    <div class="customer-info">
                      <span class="customer-name">{{ customer.name }}</span>
                      <span class="customer-email">{{ customer.email }}</span>
                    </div>
                    <i class="check-icon" *ngIf="isCustomerSelectedForMessage(customer, isSelectingCustomer)"></i>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>


        </div>
        <div class="message-content">
          <div *ngIf="isEditingMessage === msg.id; else displayContent">
            <quill-editor
              #messageEditor
              [(ngModel)]="editingMessageContent"
              [modules]="quillModules"
              [ngClass]="{'error': hasEditingMessageCyrillicError}"
              placeholder="Edit message..."
              class="custom-quill-editor">
            </quill-editor>

            <div class="error-message" *ngIf="hasEditingMessageCyrillicError">
              {{ cyrillicErrorMessage }}
            </div>

            <!-- Editing Attachments -->
            <div class="attachments" *ngIf="editingAttachments.length">
              <div class="attachment" *ngFor="let attachment of editingAttachments">
                <div class="attachment-icon" [ngClass]="getFileTypeIcon(attachment.fileType)">
                  <i class="file-type-icon"></i>
                </div>
                <span class="attachment-name">{{ attachment.fileName }}</span>
                <div class="attachment-meta">
                  <span class="file-size">{{ formatFileSize(attachment.size) }}</span>
                </div>
                <button (click)="deleteEditingAttachment(attachment)" class="delete-btn" title="Delete file">
                  <i class="delete-icon"></i>
                </button>
              </div>
            </div>

            <!-- Editing Images -->
            <div class="images" *ngIf="editingImages.length">
              <div class="image-container" *ngFor="let img of editingImages">
                <img [src]="img" class="message-image" />
                <button (click)="deleteEditingImage(img)" class="delete-btn" title="Delete image">
                  <i class="delete-icon"></i>
                </button>
              </div>
            </div>

            <!-- File Upload Section -->
            <div class="attachments-section"
                 (dragover)="onDragOver($event)"
                 (dragleave)="onDragLeave($event)"
                 (drop)="onDrop($event)"
                 [ngClass]="{'drag-over': isDragging}">
              <div class="file-input-container">
                <input
                  type="file"
                  multiple
                  (change)="onFileSelected($event)"
                  #fileInput
                  style="display: none"
                />
                <button type="button" (click)="fileInput.click()" class="btn btn-secondary attach-btn">
                  Attach Files
                  <span class="drag-hint">or drag & drop</span>
                </button>
              </div>
            </div>

            <div class="message-edit-actions">
              <button class="btn btn-primary" (click)="saveMessageEdit(msg)">Save</button>
              <button class="btn btn-secondary" (click)="cancelMessageEdit()">Cancel</button>
            </div>
          </div>
          <ng-template #displayContent>
            <div [innerHTML]="sanitizeHtml(msg.content)"></div>
            <!-- Only show attachments and images when not editing -->
            <div class="attachments" *ngIf="msg.attachments?.length && isEditingMessage !== msg.id">
              <div class="attachment" *ngFor="let attachment of msg.attachments">
                <div class="attachment-icon" [ngClass]="getFileTypeIcon(attachment.fileType)">
                  <i class="file-type-icon"></i>
                </div>
                <span class="attachment-name">{{ attachment.fileName }}</span>
                <div class="attachment-meta">
                  <span class="file-size">{{ formatFileSize(attachment.size) }}</span>
                </div>
                <button (click)="downloadAttachment(attachment)" class="download-btn" ngbTooltip="Download file">
                  <i class="download-icon"></i>
                </button>
              </div>
            </div>
            <div class="images" *ngIf="msg.imageUrls?.length && isEditingMessage !== msg.id">
              <img *ngFor="let img of msg.imageUrls" [src]="img" class="message-image" />
            </div>
          </ng-template>
        </div>
      </div>
      <div *ngIf="messages.length === 0">No messages for this topic.</div>
    </div>

    <form [formGroup]="messageForm" (ngSubmit)="onSubmit()" class="message-form">
      <!-- File attachments section -->
      <div class="attachments-section"
           (dragover)="onDragOver($event)"
           (dragleave)="onDragLeave($event)"
           (drop)="onDrop($event)"
           [ngClass]="{'drag-over': isDragging}">
      <div class="editor-container">
        <div class="editor-content">
          <quill-editor
            #editor
            formControlName="message"
            [modules]="quillModules"
            [ngClass]="{'error': hasMessageCyrillicError}"
            placeholder="Write a message..."
            class="custom-quill-editor">
          </quill-editor>

          <!-- Validation message for empty message -->
          <div class="validation-message" *ngIf="submitted && f['message'].errors?.['required']">
            Please enter a message before sending
          </div>

          <!-- Cyrillic error message -->
          <div class="error-message" *ngIf="hasMessageCyrillicError">
            {{ cyrillicErrorMessage }}
          </div>
        </div>

        <div class="file-input-container">
          <input
            type="file"
            multiple
            (change)="onFileSelected($event)"
            #fileInput
            style="display: none"
          />
          <button type="button" (click)="fileInput.click()" class="attach-btn" ngbTooltip="Attach Files">
            <i class="bi bi-paperclip"></i>
          </button>
          <button
            type="submit"
            [disabled]="isSending || messageForm.invalid || !selectedTopic"
            class="send-btn"
            ngbTooltip="Send Message">
            <i class="bi bi-send"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="selected-files" *ngIf="attachments.length">
      <div class="attachment" *ngFor="let attachment of attachments">
        <div class="attachment-icon" [ngClass]="getFileTypeIcon(attachment.fileType)">
          <i class="file-type-icon"></i>
        </div>
        <span class="attachment-name">{{ attachment.fileName }}</span>
        <button (click)="removeAttachment(attachment)" class="delete-btn" title="Delete file">
          <i class="delete-icon"></i>
        </button>
      </div>
    </div>
    </form>
  </section>
</div>

<!-- Notification Dialog -->
<!--<div class="notification-dialog" *ngIf="showNotification">
  <div class="notification-content">
    <div class="notification-message">{{ notificationMessage }}</div>
    <div class="notification-actions">
      <button (click)="handleNotificationAction('view')" class="btn btn-primary">View Message</button>
      <button (click)="handleNotificationAction('dismiss')" class="btn btn-secondary">Dismiss</button>
    </div>
  </div>
</div> -->
